<script setup>
import { computed, onMounted, ref } from "vue";
import HeaderTitle from "@/components/layout/HeaderTitle";
import SecuritySectionTitle from "@/components/security/SecuritySectionTitle.vue";
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import EmployeePermissionService from "@/api/services/employeePermission.service";

const page = ref(1); const itemsPerPage = ref(10); const filters = ref({ module: "", action: "" });
const catalogRows = ref([]);

const loadCatalog = () => {
  EmployeePermissionService.getCatalogActions().then((res) => {
    if (!res) return;
    catalogRows.value = (res.data ?? []).flatMap((mod) =>
      mod.actions.map((action) => ({
        id: `${mod.module}:${action.value}`,
        module: mod.label,
        moduleValue: mod.module,
        action: action.label,
        actionValue: action.value,
      }))
    );
  });
};

const modules = computed(() => [...new Set(catalogRows.value.map(({ module }) => module))]);
const actions = computed(() => [...new Set(catalogRows.value.map(({ action }) => action))]);

const filteredCatalog = computed(() => catalogRows.value.filter((item) => (!filters.value.module || item.module === filters.value.module) && (!filters.value.action || item.action === filters.value.action)));
const listedCatalog = computed(() => filteredCatalog.value.slice((page.value - 1) * itemsPerPage.value, page.value * itemsPerPage.value));
const search = () => { page.value = 1; };

onMounted(() => {
  loadCatalog();
});
</script>

<template>
    <section class="permission-catalog">
        <HeaderTitle title="Seguridad" />
        <SecuritySectionTitle title="Catálogo de permisos" /><el-row class="mt-2"><el-card class="card-search catalog-filters w-100 wback" body-style="padding:0">
                <div class="search-form">
                    <div class="row">
                        <div class="col-4 el-col-xs-24">
                            <div class="form-item"><label>Módulo</label><el-select v-model="filters.module"
                                    class="w-100" placeholder="Todos" clearable filterable @change="search"><el-option
                                        v-for="item in modules" :key="item" :label="item" :value="item" /></el-select>
                            </div>
                        </div>
                        <div class="col-4 el-col-xs-24">
                            <div class="form-item"><label>Acción válida</label><el-select v-model="filters.action"
                                    class="w-100" placeholder="Todos" clearable filterable @change="search"><el-option
                                        v-for="item in actions" :key="item" :label="item" :value="item" /></el-select>
                            </div>
                        </div>
                        <div class="col-4 el-col-xs-24 catalog-filters__action"><button class="btn btn_yellow"
                                @click="search">BUSCAR</button></div>
                    </div>
                </div>
            </el-card></el-row>
        <div class="table table-not-mobile catalog-table">
            <table>
                <thead>
                    <tr>
                        <th>Módulo</th>
                        <th>Acción válida</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in listedCatalog" :key="item.id">
                        <td>{{ item.module }}</td>
                        <td>{{ item.action }}</td>
                    </tr>
                </tbody>
            </table>
            <p v-if="!filteredCatalog.length" class="empty">No se han encontrado permisos con los filtros seleccionados.
            </p>
        </div>
        <div class="table-mobile catalog-mobile"><el-card v-for="item in listedCatalog" :key="item.id">
                <p><b>Módulo:</b>{{ item.module }}</p>
                <p><b>Acción válida:</b>{{ item.action }}</p>
            </el-card>
            <p v-if="!filteredCatalog.length" class="empty">No se han encontrado permisos con los filtros seleccionados.
            </p>
        </div>
        <SharedElementPagination v-model:current-page="page" v-model:page-size="itemsPerPage"
            :total="filteredCatalog.length" :page-size-options="[10, 20, 50]" class="pagination"
            @size-change="page = 1" />
    </section>
</template>

<style lang="scss" scoped>
.permission-catalog {
    color: #30385d
}

.security-subtitle {
    align-items: center;
    display: flex;
    margin-bottom: 12px
}

.security-subtitle .svg-inline--fa {
    color: #474ce6;
    font-size: 27px
}

.security-subtitle .title-text {
    color: #474ce6;
    font-size: 2.5em;
    margin-left: 1rem
}

.catalog-filters {
    background: #fff !important;
    background-image: none !important;
    border-radius: 15px
}

.catalog-filters__action {
    align-items: flex-end;
    display: flex;
    justify-content: flex-end
}

.catalog-filters__action .btn {
    color: #474ce6 !important;
    font-weight: 800;
    height: 40px;
    margin: 0 !important;
    min-height: 40px;
    padding: 0 18px;
    width: 150px
}

.catalog-table table {
    min-width: 720px
}

.catalog-table th {
    text-transform: uppercase
}

.catalog-table td {
    vertical-align: middle
}

.table-mobile {
    display: none
}

.pagination {
    display: flex;
    justify-content: center;
    margin: 16px 0 22px
}

.empty {
    color: #7c83a2;
    text-align: center
}

@media(max-width:767px) {
    .table-not-mobile {
        display: none
    }

    .table-mobile {
        display: grid;
        gap: 12px
    }

    .security-subtitle .title-text {
        font-size: 2em
    }

    .catalog-filters {
        background: #fff !important
    }

    .catalog-filters__action {
        justify-content: center;
        margin-left: 0;
        margin-top: 10px
    }

    .catalog-filters__action .btn {
        width: 100%
    }

    .catalog-mobile :deep(.el-card__body) {
        padding: 14px
    }

    .catalog-mobile p {
        display: grid;
        gap: 7px;
        grid-template-columns: 130px minmax(0, 1fr);
        margin: 9px 0 0;
        word-break: break-word
    }

    .catalog-mobile p b {
        color: #474ce6
    }

    .pagination {
        overflow: hidden
    }
}
</style>
